import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { EmailRoute } from '@/types/integrations.ts';
import { INTEGRATION_CONFIG_EMAIL_ROUTES_KEY } from '@/utils/queryKeys.ts';
import { get_email_alias_url } from '@/utils/urls.ts';

type UpdateEmailAliasParams = {
  stepId: string;
  routeId: string;
  localPart: string;
};

const useUpdateEmailAlias = (): UseMutationResult<EmailRoute, AxiosError, UpdateEmailAliasParams> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ stepId, routeId, localPart }) => {
      const response = await apiClient.patch<EmailRoute>(get_email_alias_url(automationId, stepId, routeId), {
        local_part: localPart,
      });
      return response.data;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: INTEGRATION_CONFIG_EMAIL_ROUTES_KEY(automationId, variables.stepId),
      });
    },
  });
};

export default useUpdateEmailAlias;
